import React, { FC, useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectNext4MatingBatches } from 'shared/state/ducks/mating-batch/operations';
import { localized } from 'shared/state/i18n/i18n';
import { SkioldFormDatePicker } from 'web/view/components/skiold-components/skiold-date-picker/skiold-form-datepicker';
import SkioldTableGrid from 'web/view/components/skiold-components/skiold-table/skiold-table-grid/skiold-table-grid';
import { ViewWeb } from 'web/view/components/utils/web-view';
import { TextWeb } from 'web/web-helpers/styled-text-components';
import { PeriodTableItem, PeriodTableRow } from '../production-report/p-report-period-table';
import { useWeekReportContext } from './week-report-overview';
import './week-report.scss';
export interface PropsFromParent {}

const columnExt: any = [
	{
		name: 'period1',
		width: 192.5,
	},
	{
		name: 'period2',
		width: 192.5,
	},
	{
		name: 'period3',
		width: 192.5,
	},
	{
		name: 'period4',
		width: 192.5,
	},
];

export const WeekReportDatePicker: FC<PropsFromParent> = React.memo(props => {
	const matingBatches = useSelector(selectNext4MatingBatches);

	const { currentRows, setCurrentRows } = useWeekReportContext();
	useEffect(() => {
		const dataItems: PeriodTableRow[] = [];
		let fromItems: PeriodTableItem[] = [];
		let toItems: PeriodTableItem[] = [];
		if (matingBatches) {
			const periods = matingBatches.map((matingBatch, index) => {
				const from = new PeriodTableItem(localized('FromDate'), matingBatch.matingPeriodStart, index + 1, true);
				const to = new PeriodTableItem(localized('ToDate'), matingBatch.matingPeriodEnd, index + 1, false);

				return { from, to };
			});
			fromItems = periods.map(period => period.from);
			toItems = periods.map(period => period.to);
		}

		fromItems.sort((a, b) => (a.periodNumber > b.periodNumber ? 1 : -1));
		toItems.sort((a, b) => (a.periodNumber > b.periodNumber ? 1 : -1));
		dataItems.push(new PeriodTableRow(fromItems));
		dataItems.push(new PeriodTableRow(toItems));

		setCurrentRows(dataItems);
	}, [matingBatches, setCurrentRows]);

	const setDate = useCallback(
		(date: Date, itemFromParent?: PeriodTableItem) => {
			const rowToChange = currentRows.find(row =>
				row.items?.some(
					item =>
						item.periodNumber === itemFromParent?.periodNumber &&
						item.isFromDate === itemFromParent?.isFromDate,
				),
			);
			if (rowToChange && rowToChange.items) {
				const itemToChange = rowToChange.items.find(
					item =>
						item.periodNumber === itemFromParent?.periodNumber &&
						item.isFromDate === itemFromParent?.isFromDate,
				);
				if (itemToChange) {
					itemToChange.date = date;
					setCurrentRows([...currentRows]);
				}
			}
		},
		[currentRows, setCurrentRows],
	);
	const generateDatePicker = useCallback(
		(item: PeriodTableItem) => {
			return (
				<ViewWeb className="period-item-container">
					<TextWeb>{item.name}</TextWeb>
					<SkioldFormDatePicker
						onDateChanged={setDate}
						selectedDate={item.date}
						itemFromParent={item}
						containerClassName="marginRightTen"
						includeTimeStamp={false}
						theme={'dark'}
						color={'grey'}
						maxDate={new Date(8640000000000000)}
						isEndDate={item.isFromDate ? false : true}
						showIcon={true}
					/>
				</ViewWeb>
			);
		},
		[setDate],
	);

	const generateColumns = useMemo(() => {
		const columns: any = [
			{
				name: 'period1', //sow team
				title: `${localized('period')} 1`,
				sortable: false,
				filterable: false,
				getCellValue: (period: PeriodTableRow) => generateDatePicker(period.items![0]),
			},
			{
				name: 'period2', //sow team
				title: `${localized('period')} 2`,
				sortable: false,
				filterable: false,
				getCellValue: (period: PeriodTableRow) => generateDatePicker(period.items![1]),
			},
			{
				name: 'period3', //sow team
				title: `${localized('period')} 3`,
				sortable: false,
				filterable: false,
				getCellValue: (period: PeriodTableRow) => generateDatePicker(period.items![2]),
			},
			{
				name: 'period4', //sow team
				title: `${localized('period')} 4`,
				sortable: false,
				filterable: false,
				getCellValue: (period: PeriodTableRow) => generateDatePicker(period.items![3]),
			},
		];

		return columns;
	}, [generateDatePicker]);

	return (
		<ViewWeb className="p-report-period-table">
			<SkioldTableGrid
				ColumnExtensions={columnExt}
				columns={generateColumns}
				data={currentRows}
				sortable={false}
				filterable={false}
			/>
		</ViewWeb>
	);
});
